import { TableRow, TableCell, IconButton, Collapse, Typography, Grid } from "@mui/material";
import { useState } from "react";
import { TWebhookEvent } from "../../../interfaces/audits";
import { ICarrierAudit } from "../../../interfaces/order";
import { mongoTimeStampToString } from "../../../utils/orders";

const CollapsibleWebhookRow = ({
  entry,
  idx,
  colSpan,
  carrierAudit,
  carrierName,
}: {
  entry: TWebhookEvent;
  idx: number;
  colSpan: number;
  carrierAudit: ICarrierAudit;
  carrierName: string;
}) => {
  const [open, setOpen] = useState(false);

  const receivedAt = entry.calledAt ? mongoTimeStampToString(entry.calledAt) : "-";
  const processedAt = entry.processedAt ? mongoTimeStampToString(entry.processedAt) : "-";
  const operatorName = entry.operator ?? carrierName;

  const validTransition: boolean | undefined =
    typeof entry.valid_transition === "boolean"
      ? entry.valid_transition
      : undefined;

  const internalChangeLabel = (() => {
    if (validTransition === false) return "Sin cambios";
    const before = entry.status_internal_before ?? "";
    const after = entry.status_internal_after ?? "";
    return before || after ? `${before} → ${after}` : "-";
  })();

  const validLabel = (() => {
    if (validTransition === undefined) return "-";
    return validTransition ? "Sí" : "No";
  })();

  const retryCount =
    typeof entry.retry_count === "number" ? entry.retry_count : 0;

  return (
    <>
      <TableRow key={entry.event_id || idx}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            <span className="material-symbols-rounded">
              {open ? "expand_less" : "expand_more"}
            </span>
          </IconButton>
          {receivedAt}
        </TableCell>
        <TableCell>{processedAt}</TableCell>
        <TableCell>{operatorName}</TableCell>
        <TableCell>{entry.status_received || "-"}</TableCell>
        <TableCell>{internalChangeLabel}</TableCell>
        <TableCell>{validLabel}</TableCell>
        <TableCell>{retryCount}</TableCell>
      </TableRow>
      <TableRow
        key={`${entry.event_id || idx}-details`}
        sx={{
          "& > td": {
            p: open ? 4 : 0,
            opacity: open ? 1 : 0,
            borderBottom: open ? undefined : "none",
            transition: "padding 0.2s ease, opacity 0.2s ease",
          },
        }}
      >
        <TableCell colSpan={colSpan}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Typography className="text-bold" fontSize={13} gutterBottom>
              Detalles
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography fontSize={13}>
                  <b>Tracking:</b>{" "}
                  {entry.tracking_number || carrierAudit.tracking_id}
                </Typography>
                <Typography fontSize={13}>
                  <b>Manejado por:</b> {entry.handled_by || "-"}
                </Typography>
                <Typography fontSize={13}>
                  <b>Trace ID:</b> {entry.trace_id || "-"}
                </Typography>
                <Typography fontSize={13}>
                  <b>Event ID:</b> {entry.event_id || "-"}
                </Typography>
                {validTransition === false && entry.rejection_reason && (
                  <Typography fontSize={13} color="error">
                    <b>Motivo de rechazo:</b> {entry.rejection_reason}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography fontSize={13} className="text-bold">
                  Payload
                </Typography>
                <pre>
                  <code>{JSON.stringify(entry.body || {}, null, 2)}</code>
                </pre>
              </Grid>
            </Grid>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CollapsibleWebhookRow;
